module.exports = __webpack_public_path__ + "img/Support-skill-420.5ae943a5.png";